import { render, staticRenderFns } from "./roles-formulario.vue?vue&type=template&id=9ded132e&scoped=true&"
import script from "./roles-formulario.vue?vue&type=script&lang=js&"
export * from "./roles-formulario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ded132e",
  null
  
)

export default component.exports